import { FeatureFlagConfig } from './types'

const featureFlagsConfig: FeatureFlagConfig = {
  loginEnabled: {
    env: process.env.LOGIN_ENABLED,
    defaultValue: false,
  },
}

export default featureFlagsConfig
